import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    margin: '0 auto'
  }
}));
